import { nowISO, parseDateTime } from 'utils/dateUtils';

export const useCurrentTimeOfDay = (timezone: string) => {
  const currentTime = parseDateTime(nowISO(), {
    zone: timezone,
  });
  const hour = currentTime.hour;
  if (hour >= 6 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 24) return 'evening';
  return 'night';
};
